import produce from 'immer';

import { ReducerAction } from 'store/modules/types';

import { Types, ConsultarCinPPTState } from './types';

export const INITIAL_STATE: ConsultarCinPPTState = {
	status: 0,
	data: null,
	dataFailure: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultarCinPPTState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_CIN_PPT_REQUEST: {
				draft.status = 100;
				draft.data = INITIAL_STATE.data;
				draft.dataFailure = INITIAL_STATE.dataFailure;
				break;
			}
			case Types.CONSULTAR_CIN_PPT_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				draft.dataFailure = INITIAL_STATE.dataFailure;
				break;
			}
			case Types.CONSULTAR_CIN_PPT_FAILURE: {
				draft.data = INITIAL_STATE.data;
				draft.dataFailure = action.payload.data;
				draft.status = 400;
				break;
			}
			case Types.CONSULTAR_CIN_PPT_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.dataFailure = INITIAL_STATE.dataFailure;
				break;
			}

			default:
		}
		return draft;
	});
}
